// extracted by mini-css-extract-plugin
export var buttons = "_bh-0";
export var buttonsActive = "_bh-h";
export var cancelConfirm = "_bh-1";
export var closeButton = "_bh-2";
export var column = "_bh-3";
export var container = "_bh-4";
export var detailHeader = "_bh-6";
export var detailTitle = "_bh-7";
export var detailsContent = "_bh-5";
export var header = "_bh-8";
export var headerWithClose = "_bh-9";
export var icon = "_bh-a";
export var infoIcon = "_bh-c";
export var informationContainer = "_bh-b";
export var sideDrawer = "_bh-d";
export var sideDrawerOpen = "_bh-e";
export var stickyFooter = "_bh-f";
export var typeOption = "_bh-g";